import { useState } from "react";
import "./detailpage.css";
import suctionimage from "../../images/orthoimplants.jpg";
import hipudrapebanner from "../../images/orthopedic-page-banner.jpg";
import { FaWhatsapp } from "react-icons/fa";
import OrthopedicSuctionTubemultiple from "../../images/Orthopedic-Suction-tube.png";

const whatsappNumber = "+919619065205";
const whatsappMessage = `https://wa.me/+919619065205?text=Hi! I'm interested in your medical products. Please provide more information.`;

const OrthopedicSuctionTube = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="page-sagittal">
      <nav className="breadcrumbs">
        <a href="/">Home</a> <span>›</span>
        <a href="/products">Products</a> <span>›</span>
        <a href="/products/surgical-consumables">Orthopaedics</a> <span>›</span>
        Orthopedic Suction Tube / Set
      </nav>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${hipudrapebanner})`,
        }}
      >
        <h1 className="homepage-hero-title"> Orthopedic Suction Tube</h1>
        <p className="homepage-hero-subtext">
          Disposable filtered suction system for high-debris orthopaedic and
          trauma procedures.
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of Orthopedic Suction Tube. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>
      <section className="product-header">
        <div className="media-card">
          <div className="main-image">
            <img src={suctionimage} alt="Orthopedic Suction Tube / Set" />
          </div>
          <div className="thumb-row">
            <div className="thumb">
              <img src={suctionimage} alt="Sterile Pack View" />
            </div>
            <div className="thumb">
              <img src={suctionimage} alt="Suction Tips" />
            </div>
            <div className="thumb">
              <img src={suctionimage} alt="Handle Close-up" />
            </div>
            <div className="thumb">
              <img src={suctionimage} alt="OR Setup" />
            </div>
          </div>
        </div>

        <div>
          <div className="badge-row">
            <span className="badge badge--primary">Orthopaedic Surgery</span>
            <span className="badge">Single-use • Sterile</span>
            <span className="badge">High-flow suction</span>
          </div>
          <h1>Orthopedic Suction Tube / Set</h1>
          <p className="subtitle">
            Disposable filtered suction system for high-debris orthopaedic and
            trauma procedures.
          </p>
          <div className="meta-row">
            <div>
              <span className="meta-label">Product Code:</span>{" "}
              <span id="prod-code">OS- 001</span>
            </div>
            <div>
              <span className="meta-label">Category:</span> Orthopaedic Suction
              Devices
            </div>
            <div>
              <span className="meta-label">Sterility:</span> Sterile, EO
              (single-use)
            </div>
          </div>
          <div className="chip-row">
            <div className="chip">
              <img
                src={OrthopedicSuctionTubemultiple}
                alt="Orthopedic Suction Tube - Sabiote Healthcare"
              />
              High-flow, debris-resistant suction
            </div>
            <div className="chip">
              <img
                src={OrthopedicSuctionTubemultiple}
                alt="Orthopedic Suction Tube - Sabiote Healthcare"
              />
              Integrated filter system
            </div>
            <div className="chip">
              <img
                src={OrthopedicSuctionTubemultiple}
                alt="Orthopedic Suction Tube - Sabiote Healthcare"
              />
              Multiple suction tips
            </div>
            <div className="chip">
              <img
                src={OrthopedicSuctionTubemultiple}
                alt="Orthopedic Suction Tube - Sabiote Healthcare"
              />
              Latex-free materials*
            </div>
          </div>
          <p className="excerpt">
            Engineered specifically for orthopaedic workflows, this disposable
            suction set efficiently removes blood, irrigation fluid, bone
            fragments, marrow and cement debris to keep the surgical field clear
            and visible. The ergonomic handle with integrated filter and
            interchangeable tips supports consistent suction performance
            throughout demanding procedures.
          </p>
          <div className="cta-row">
            <a
              href="https://wa.me/+919619065205?text=Hello! I'm interested in bulk procurement of Orthopedic Suction Tube. Please share more details."
              className="btn btn-primary"
            >
              Request a Quote
              <svg viewBox="0 0 20 20" fill="none">
                <path
                  d="M5 10h8m0 0-3-3m3 3-3 3"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            <a href="#downloads" className="btn btn-outline">
              Download Spec Sheet
            </a>
            <span className="note">
              For hospital / institutional orders, please contact our sales
              team.
            </span>
          </div>
          <div className="pill-label">
            <span>Key Applications:</span> Joint replacements (hip &amp; knee),
            spine, trauma, revision surgeries
          </div>
        </div>
      </section>
      <section className="content-grid">
        <div>
          <article className="card">
            <div className="card-subtitle">Highlights</div>
            <h2>Key Features &amp; Benefits</h2>
            <p>
              Designed to handle the heavy debris load typical of orthopaedic
              procedures, this suction set combines high-flow performance with
              effective filtration and surgeon comfort.
            </p>
            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-title">High-flow, debris-resistant</div>
                <div className="feature-text">
                  Wide lumen and optimized tip geometry help maintain consistent
                  suction even with bone fragments, cement and clots present.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Integrated filter system</div>
                <div className="feature-text">
                  Built-in filter in the handle traps solids before they reach
                  the tubing or canister, helping to minimise clogging and
                  downtime.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Quick-change filter</div>
                <div className="feature-text">
                  Optional secondary filter allows rapid replacement
                  mid-procedure, without changing the tubing line.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Ergonomic handle</div>
                <div className="feature-text">
                  Contoured design provides a secure grip and easy
                  manoeuvrability, even when gloved and under irrigation.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Multiple suction tips</div>
                <div className="feature-text">
                  Supplied with a range of straight and curved tips to match
                  different anatomical sites and approaches.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Single-use &amp; sterile</div>
                <div className="feature-text">
                  Fully disposable set supports infection-control protocols and
                  eliminates reprocessing steps.
                </div>
              </div>
            </div>
          </article>
          <article className="card">
            <div className="card-subtitle">Overview</div>
            <h2>Product Description</h2>
            <p>
              The Orthopedic Suction Tube / Set is a ready-to-use, sterile
              suction solution for orthopaedic and trauma theatres. It is
              designed for procedures that generate significant particulate
              matter, including bone cutting, reaming, cement removal and heavy
              irrigation.
            </p>
            <p>
              The ergonomic handle houses a disposable filter that captures bone
              chips, marrow, clots and cement particles before they enter the
              suction tubing. Interchangeable tips allow the surgical team to
              tailor the suction profile to the target site, whether working in
              deep cavities or around prosthetic components.
            </p>
            <p>
              The set connects easily to standard suction pumps and canisters
              using a universal connector, and the kink-resistant tubing
              maintains flow, even when routed under drapes or around the
              sterile field.
            </p>
          </article>
          <article className="card">
            <div className="card-subtitle">Technical</div>
            <h2>Technical Specifications &amp; Components</h2>
            <table className="spec-table">
              <tr>
                <th>Handle</th>
                <td>
                  Ergonomic, single-use handle with integrated particulate
                  filter.
                  <br />
                  Material: medical-grade polymer (latex-free*).
                  <br />
                  Colour: neutral / light for clear visibility of fluids and
                  debris.
                </td>
              </tr>
              <tr>
                <th>Filter</th>
                <td>
                  Disposable filter cartridge located within the handle.
                  <br />
                  Optional spare filter included in the set for mid-procedure
                  change.
                </td>
              </tr>
              <tr>
                <th>Suction Tips</th>
                <td>
                  Example configuration:
                  <br />
                  • 1 × straight tip – Ø7.8 mm × 230 mm
                  <br />
                  • 1 × curved tip – Ø7.8 mm × 220 mm
                  <br />• 1 × short curved tip – Ø7.8 mm × 140 mm
                </td>
              </tr>
              <tr>
                <th>Tubing</th>
                <td>
                  Kink-resistant suction tubing, approx. 3.0 m length (or as per
                  your specification).
                  <br />
                  Universal connector for suction pump / canister.
                </td>
              </tr>
              <tr>
                <th>Sterility</th>
                <td>
                  Sterile (e.g. EO sterilised) – single use only.
                  <br />
                  Supplied in sterile packaging with clear labelling.
                </td>
              </tr>
              <tr>
                <th>Packaging</th>
                <td>
                  Individual sterile pack.
                  <br />
                  Standard trade pack: 10 sets per box (or as per your
                  packaging).
                  <br />
                  Custom configurations available on request.
                </td>
              </tr>
              <tr>
                <th>Storage</th>
                <td>
                  Store in a cool, dry place away from direct sunlight and
                  sources of heat.
                  <br />
                  Do not use if packaging is opened, torn or damaged.
                </td>
              </tr>
            </table>
            <p className="note">
              *Confirm material composition and latex status according to your
              final bill of materials and regulatory files.
            </p>
          </article>
          <article className="card">
            <div className="card-subtitle">Clinical Use</div>
            <h2>Indications &amp; Procedures</h2>
            <p>
              The Orthopedic Suction Tube / Set is intended for the controlled
              removal of blood, irrigation fluids and surgical debris in
              procedures such as:
            </p>
            <ul>
              <li>Total hip and knee arthroplasty</li>
              <li>Revision joint replacement surgery</li>
              <li>Spinal procedures (e.g. decompression, fusion)</li>
              <li>Trauma and fracture repair surgeries</li>
              <li>
                Procedures involving bone reaming, drilling or cement removal
              </li>
            </ul>
            <p className="note">
              Use only under the supervision of appropriately trained healthcare
              professionals.
            </p>
          </article>
          <article className="card">
            <div className="card-subtitle">Safety</div>
            <h2>Safety, Sterility &amp; Handling</h2>
            <ul>
              <li>
                Supplied sterile for single use only – do not re-sterilise or
                reuse.
              </li>
              <li>
                Inspect packaging before use. Do not use if pouch is damaged or
                open.
              </li>
              <li>
                Ensure secure connection to the suction pump / canister before
                the start of the procedure.
              </li>
              <li>
                Dispose of the entire set as clinical waste according to local
                regulations after use.
              </li>
              <li>
                Avoid excessive bending or pulling on the tubing to prevent
                occlusion or disconnection.
              </li>
            </ul>
            <p className="note">
              Always refer to the Instructions for Use (IFU) packaged with the
              product for complete warnings and precautions.
            </p>
          </article>
          <article className="card" id="faq">
            <div className="card-subtitle">Support</div>
            <h2>Frequently Asked Questions</h2>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(0)}>
                Is the suction set compatible with standard hospital suction
                systems?
                <span className={`faq-arrow ${openIndex === 0 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 0 && (
                <div className="faq-a">
                  Yes. The tubing includes a universal connector designed to fit
                  most standard suction pumps and canisters.
                </div>
              )}
            </div>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(1)}>
                Can the filter be changed during a procedure?
                <span className={`faq-arrow ${openIndex === 1 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 1 && (
                <div className="faq-a">
                  If supplied with a spare filter, you may exchange the filter
                  mid-procedure following the IFU, without replacing the tubing
                  line. Always maintain sterility during filter changes.
                </div>
              )}
            </div>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(2)}>
                Is the product latex-free?
                <span className={`faq-arrow ${openIndex === 2 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 2 && (
                <div className="faq-a">
                  The set is manufactured using medical-grade polymers. Please
                  refer to the IFU and product labelling for confirmation of
                  latex and DEHP status in your market.
                </div>
              )}
            </div>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(3)}>
                What is the shelf life?
                <span className={`faq-arrow ${openIndex === 3 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 3 && (
                <div className="faq-a">
                  The shelf life is indicated on the product labelling. Do not
                  use beyond the expiry date printed on the sterile pack.
                </div>
              )}
            </div>
          </article>
        </div>
        <aside>
          <div className="card">
            <div className="card-subtitle">Ordering</div>
            <h2>Ordering Information</h2>
            <p className="side-card-text">
              Use the details below when placing purchase orders or tenders.
            </p>
            <table className="spec-table">
              <tr>
                <th>Product Name</th>
                <td>Orthopedic Suction Tube / Set</td>
              </tr>
              <tr>
                <th>Product Code</th>
                <td>OS-001</td>
              </tr>
              <tr>
                <th>Configuration</th>
                <td>Handle with integrated filter, suction tips and tubing</td>
              </tr>
              <tr>
                <th>Unit Packaging</th>
                <td>1 set / sterile pack</td>
              </tr>
              <tr>
                <th>Trade Pack</th>
                <td>10 sets / box (or as per your packaging)</td>
              </tr>
            </table>
            <div className="side-divider"></div>
            <p className="side-card-heading">Need volume pricing?</p>
            <p className="side-card-text">
              For bulk orders, annual contracts or tenders, please reach out to
              our institutional sales team.
            </p>
            <a href="/contact" className="btn btn-outline">
              Contact Sales
            </a>
          </div>
          <div className="card">
            <div className="card-subtitle">Quality</div>
            <h2>Compliance &amp; Quality</h2>
            <p className="side-card-text">
              Manufactured in a facility operating under recognised quality and
              regulatory standards.
            </p>
            <div className="pill-stack">
              <div className="pill">Single-use / sterile</div>
              <div className="pill">For professional use only</div>
              <div className="pill">Latex-free* (if applicable)</div>
              <div className="pill">Manufactured under ISO 13485*</div>
              <div className="pill">Regulatory approvals as per market*</div>
            </div>
            <p className="note">
              *Update compliance statements to match your actual certifications
              and registrations.
            </p>
          </div>
          <div className="card" id="downloads">
            <div className="card-subtitle">Resources</div>
            <h2>Downloads</h2>
            <ul className="download-list">
              <li>
                <a
                  href="orthopedic-suction-set-spec-sheet.pdf"
                  className="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M5 9v6.5A1.5 1.5 0 0 0 6.5 17h7A1.5 1.5 0 0 0 15 15.5V9"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10 3v9m0 0 3-3.2M10 12 7 8.8"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Product Specification Sheet (PDF)
                </a>
              </li>
              <li>
                <a
                  href="orthopedic-suction-set-ifu.pdf"
                  className="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M4 14.5V5.5A1.5 1.5 0 0 1 5.5 4h9"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6 9h3m-3 3h5m3.5-8v10A1.5 1.5 0 0 1 13 15.5H6"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                  </svg>
                  Instructions for Use (IFU)
                </a>
              </li>
              <li>
                <a
                  href="orthopedic-suction-set-sterility-certificate.pdf"
                  className="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <circle
                      cx="10"
                      cy="10"
                      r="7"
                      stroke="currentColor"
                      strokeWidth="1.4"
                    />
                    <path
                      d="M10 6.3v4.1"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                    <circle cx="10" cy="13.4" r="0.7" fill="currentColor" />
                  </svg>
                  Sterility / Compliance Certificates
                </a>
              </li>
            </ul>
          </div>

          <div className="card" id="contact">
            <div className="card-subtitle">Enquiries</div>
            <h2>Talk to Our Team</h2>
            <p className="side-card-text">
              Share your requirement (annual volume, procedure mix, tender
              reference) and we’ll respond with a tailored quotation.
            </p>
            <p className="side-card-text">
              Email: <a href="mailto:sales@sabiote.in">sales@sabiote.in</a>
              <br />
              <br />
              <a
                href={whatsappMessage}
                target="_blank"
                rel="noopener noreferrer"
                className="callback-btn"
              >
                <FaWhatsapp /> Book a Callback
              </a>
            </p>
          </div>
        </aside>
      </section>

      <footer className="footer-note">
        <strong>Disclaimer:</strong> This product is intended for use by trained
        healthcare professionals only. Always refer to the current Instructions
        for Use and local regulatory guidelines before use. Product features,
        specifications and availability may vary by country.
      </footer>
    </div>
  );
};

export default OrthopedicSuctionTube;
